import TextSearchPicker from './TextSearchPicker'

export default TextSearchPicker
